export const state = () => ({
  page: 0,
  batches: [],
  filters: '',
});

export const getters = {
  getBatches(store) {
    return store.batches;
  },
  getPage(store) {
    return store.page;
  },
  getFilters(store) {
    return store.filters;
  },
};

export const mutations = {
  reset(store) {
    store.page = 0;
    store.batches = [];
    store.filters = '';
  },
  setBatches(store, payload) {
    store.batches = payload;
  },
  clearBatches(store) {
    store.batches = [];
  },
  setPage(store, payload) {
    store.page = payload;
  },
  setFilters(store, payload) {
    store.filters = payload;
  },
};

export const actions = {
  async reset({ commit }) {
    commit('reset');
  },
  async getBatches({ commit, state }) {
    let url = 'batch?results=1000';
    if (state.page) {
      url += `&page=${state.page}`;
    }
    if (state.filters) {
      url += state.filters;
    }

    const batches = await this.$axios.$get(url);
    batches.batch_list.map((batch) => {
      batch.title = `${batch.vehicle_no} ${batch.manufacturer} ${batch.model} ${batch.color} ${batch.available_on}`;
    });

    commit('setBatches', batches.batch_list);
  },
  async clearBatches({ commit }) {
    commit('clearBatches');
  },
  async setPage({ commit }, payload) {
    commit('setPage', payload);
  },
  async setFilters({ commit }, payload) {
    commit('setFilters', payload);
  },
};
